export default "__VITE_ASSET__CxCTifJ___"